<app-breadcrumbs
	title="Chartjs"
	[breadcrumbItems]="breadCrumbItems"
></app-breadcrumbs>

<div class="alert alert-info text-center">
	Here is the comparison of the real leads of the previous year against the
	leads that were forecast for this year
</div>

<div class="row">
	<div class="col-xl-12">
		<div class="card">
			<div class="card-header">
				<h4 class="card-title mb-0">Comparative Report 2022 - 2023</h4>
			</div>
			<div class="card-body" style="display: block" *ngIf="lineAreaChart">
				<canvas
					baseChart
					height="300"
					[datasets]="lineAreaChart.datasets"
					[labels]="lineAreaChart.labels"
					[options]="lineAreaChart.options"
					[type]="'line'"
				>
				</canvas>
			</div>
		</div>
	</div>
</div>
<!-- end row -->
